import React, { FC, useCallback, useEffect, useState } from 'react';
import Measurement from '@arcgis/core/widgets/Measurement';
import { getView } from '../../map';
import GridButton from '../../common/components/GridButton';
import { Crop, GitPullRequest } from 'react-feather';
import { setIsMapSelectable } from '../../map/layers/SelectionLayer';

const MeasurementTool: FC = () => {
  const [tool, setTool] = useState<__esri.Measurement | null>(null)
  useEffect(() => {
    const activateMeasurementTool = () => {
      const view = getView()
      if (!view) {
        setTimeout(activateMeasurementTool, 100)
        return
      }
      const newTool = new Measurement({
        view,
      })
      view.ui.add(newTool, 'bottom-right')
      setTool(newTool)
    }

    if (!tool) {
      activateMeasurementTool()
    } else {
      return () => {
        setIsMapSelectable(true)
        tool.destroy()
        setTool(null)
      }
    }
  }, [tool])

  const activateDistanceTool = useCallback(() => {
    if (tool) {
      tool.clear()
      tool.activeTool = 'distance'
      setIsMapSelectable(false)
    }
  }, [tool])

  const activateAreaTool = useCallback(() => {
    if (tool) {
      tool.clear()
      tool.activeTool = 'area'
      setIsMapSelectable(false)
    }
  }, [tool])

  return (
    <div className="grid mobile-hidden">
      <div className="col-1-2">
        <GridButton
          Icon={GitPullRequest}
          onClick={activateDistanceTool}
          buttonText="Distance"
        />
      </div>
      <div className="col-1-2">
        <GridButton
          Icon={Crop}
          onClick={activateAreaTool}
          buttonText="Area"
        />
      </div>
    </div>
  )
}

export default MeasurementTool